import React from "react";
import "url-polyfill"; /* https://www.npmjs.com/package/url-polyfill */
import { Helmet } from "react-helmet"; /* https://github.com/nfl/react-helmet"; */
import i18n from "../../i18next";
import { Container, Row } from "reactstrap";
import heroImageUrl from "../../images/portfolioHeroSpoon/heroSpoonHero.jpg";
import HeroContainer from "./commons/HeroContainer";
import IntroductionSection from "./commons/IntroductionSection";
import heroSpoonLogo from "../../images/portfolioHeroSpoon/logo.png";
import { DesktopView, MobileiXBlackView } from "./commons/WorkGallery";
import { ConceptKeyPointsListSection } from "./commons/ConceptSection";
import NextIndicatorSection from "./commons/NextIndicatorSection";

/* screenshots */
import desktopScreenshotURL01 from "../../images/portfolioHeroSpoon/desktopScreenshot01.jpg";
import desktopScreenshotURL02 from "../../images/portfolioHeroSpoon/desktopScreenshot02.jpg";
import desktopScreenshotURL03 from "../../images/portfolioHeroSpoon/desktopScreenshot03.jpg";
import mobileScreenshotURL01 from "../../images/portfolioHeroSpoon/mobileScreenshot01.jpg";
import mobileScreenshotURL02 from "../../images/portfolioHeroSpoon/mobileScreenshot02.jpg";
import mobileScreenshotURL03 from "../../images/portfolioHeroSpoon/mobileScreenshot03.jpg";
import mobileScreenshotURL04 from "../../images/portfolioHeroSpoon/mobileScreenshot04.jpg";
import mobileScreenshotURL05 from "../../images/portfolioHeroSpoon/mobileScreenshot05.jpg";
// import mobileScreenshotURL06 from "../../images/portfolioHeroSpoon/mobileScreenshot06.jpg";
// import mobileScreenshotURL07 from "../../images/portfolioHeroSpoon/mobileScreenshot07.jpg";
// import mobileScreenshotURL08 from "../../images/portfolioHeroSpoon/mobileScreenshot08.jpg";

export default class HeroSpoon extends React.Component {
  constructor(props) {
    super(props);
    this.state = { windowScrollY: 0 };
  }

  componentDidMount() {
    /* inital scoll settting to be on the top */
    window.scrollTo(0, 0);

    window.onscroll = () => {
      /* need to set scroll in parent prevent glitch */
      this.setState({ windowScrollY: window.scrollY });
    }
  }

  render() {
    const url = new URL(window.location.href);
    const helmetContent = i18n.t("HeroSpoonPortfolio.introduction");
    const helmetTitle = `${i18n.t("HeroSpoonPortfolio.abbriTitle")} - ${i18n.t("jsonLdOrganization.shortCompName")}`;
    return (
      <div className="specificPortfolio">
        <Helmet>
          <title>{helmetTitle}</title>
          <meta name="description" content={helmetContent} />
          {/* Open Graph Protocal (Facebook), see: http://ogp.me/ */}
          <meta property="og:title" content={helmetTitle} />
          <meta property="og:url" content={`${url.href}`} />
          <meta property="og:image" content={desktopScreenshotURL01} />
          <meta property="og:description" content={helmetContent} />
          {/* canonical url, see: https://support.google.com/webmasters/answer/139066 */}
          <link rel="canonical" href={`${url.href}`} />
        </Helmet>
        <HeroContainer
          heroImageUrl={heroImageUrl}
          title="HeroSpoon"
        />
        <Container fluid={true} className="mainSections">
          <div className="pt-2 pt-md-3 pt-lg-4">
            <IntroductionSection
              title="HeroSpoon"
              squareImgUrl={heroSpoonLogo}
              description={i18n.t("HeroSpoonPortfolio.introduction")}
              yearMonthText="November 2016"
              windowScrollY={this.state.windowScrollY}
              externalLinkURL={"https://www.facebook.com/HeroSpoon/"}
            />
            <Container>
              <Row className="showCaseSection p-1 p-sm-2 px-lg-4 py-md-3">
                <DesktopView
                  screenshotUrls={[desktopScreenshotURL01, desktopScreenshotURL02, desktopScreenshotURL03]}
                />
                <MobileiXBlackView
                  screenshotUrls={[mobileScreenshotURL01, mobileScreenshotURL02, mobileScreenshotURL03, mobileScreenshotURL04, mobileScreenshotURL05]}
                />
                <ConceptKeyPointsListSection
                  keyPoints={i18n.t("HeroSpoonPortfolio.keypoints", { returnObjects: true })}
                />
              </Row>
            </Container>
            <NextIndicatorSection
              linkTo={"/portfolio/iRetailAR"}
              linkText={i18n.t("iRetailARPortfolio.abbriTitle")}
              windowScrollY={this.state.windowScrollY}
            />
          </div>
        </Container>
      </div>
    )
  }
}